import { Toast } from "@base-ui/react/toast";
import { CircleAlertIcon, CircleCheckIcon, XIcon } from "lucide-react";
import { cn } from "cn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx";

const toastManager = Toast.createToastManager();

export const toast = {
  success: (title: string, description?: string) =>
    toastManager.add({ title, description, type: "success" }),
  error: (title: string, description?: string) =>
    toastManager.add({ title, description, type: "error", priority: "high" }),
};

function ToastList() {
  const { toasts } = Toast.useToastManager();
  return toasts.map((item) => (
    <Toast.Root
      key={item.id}
      toast={item}
      className={cn(
        "bg-popover text-popover-foreground ring-foreground/10 flex w-80 items-start gap-2 rounded-lg p-3 text-sm shadow-lg ring-1",
        "data-ending-style:opacity-0 data-starting-style:opacity-0 transition-opacity",
      )}
    >
      {item.type === "error" ? (
        <CircleAlertIcon aria-hidden className="text-destructive mt-0.5 size-4 shrink-0" />
      ) : (
        <CircleCheckIcon aria-hidden className="mt-0.5 size-4 shrink-0 text-emerald-600" />
      )}
      <Toast.Content className="min-w-0 flex-1">
        <Toast.Title className="font-medium" />
        <Toast.Description className="text-muted-foreground" />
      </Toast.Content>
      <Tooltip>
        <TooltipTrigger
          render={
            <Toast.Close
              aria-label="关闭提示"
              className="text-muted-foreground hover:text-foreground"
            />
          }
        >
          <XIcon aria-hidden className="size-4" />
        </TooltipTrigger>
        <TooltipContent>关闭提示</TooltipContent>
      </Tooltip>
    </Toast.Root>
  ));
}

export function Toaster() {
  return (
    <Toast.Provider toastManager={toastManager}>
      <Toast.Portal>
        <Toast.Viewport
          data-slot="toast-viewport"
          aria-label="通知"
          className="fixed top-4 right-4 z-[100] flex flex-col gap-2 outline-none"
        >
          <ToastList />
        </Toast.Viewport>
      </Toast.Portal>
    </Toast.Provider>
  );
}
